export default __webpack_public_path__ + "static/Outfit-SemiBold-e36809453c41c539ea10513d4b715151.woff2";